<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 72px; justify-content: center; display: flex">
            <!-- Content Row -->
            <div class="card shadow mb-4 col-md-6 p-0">
                <div class="card-header py-2" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white small">
                        <span v-if="dados.cliente != null">Picking: {{ id }} - {{ dados.cliente }}</span>
                        <span v-else>Carregando... </span>
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </h6>
                </div>
                <fieldset v-if="dados.cliente != null" :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark p-2">
                        <div>
                            <div class="text-center col-auto p-0">
                                <div class="col p-0">
                                    <div class="col p-0 text-left">
                                        <div class="form-row justify-content-sm-between flex-fill px-1 mb-1">
                                            <div class="w-100 text-center">
                                                <span class="text-danger"
                                                    ><b>{{ endereco }}</b></span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            inputPlaceHolderSufixo="Digite o produto aqui"
                                            titleScan="Escanear produto"
                                            typeInputMode="text"
                                            @displayScanFunction="onDecode"
                                            @input="() => (errors = [])"
                                            :enterKey="handleInput"
                                            idInput="barras"
                                            autofocus
                                            v-model="barras"
                                            :errorMessage="errors.barras ? errors.barras[0] : ''"
                                            :showChangeInputMode="url.includes('localhost') || url.includes('hkcoletor')"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>

                                <div class="form-row mt-2 px-2 small">
                                    <div class="text-left lh-lg h-auto w-100">

                                        <span class="text-danger font-weight-bold">{{ dados.item.produto }}</span>
                                        <hr class="my-2">
                                        
                                        <b>Produto:</b> [<span class="text-danger font-weight-bold" v-if="url.includes('localhost') || url.includes('hkcoletor')">{{ dados.item.codbarras }}</span>
                                        <span class="text-danger font-weight-bold no-copy" v-if="!url.includes('localhost') && !url.includes('hkcoletor')">{{ dados.item.codbarras }}</span>]
                                        <br />
                                        <b>Possui Validade:</b> [{{ dados.item.possuivalidade }}]
                                        <br />
                                        <b>Lote / Validade: </b>
                                        <span v-if="dados.item.lote"> [{{ dados.item.lote }}] - </span>
                                        <span v-if="dados.item.validade">
                                            [{{ dateFormat(dados.item.validade) }}]
                                        </span>
                                        <br>
                                        <div style="display: flex; align-items: center; justify-content: space-between;">
                                            <div><b>Quantidade</b> {{ dados.item.qtde_lista }} / {{ dados.item.qtde }}</div>
                                            <div><b v-show="dados.item.cesta">Cesta</b> <span class="text-danger"><b>{{ dados.item.cesta }}</b></span></div>
                                        </div>
                                        <div class="mt-2" style="display: flex; align-items: center">
                                            <div style="flex: 1;">
                                                <div
                                                    class="progress lh-lg p-0"
                                                    style="height: 1.8em; display: flex; justify-content: center"
                                                >
                                                    <div
                                                        class=" progress-bar progress-bar-striped progress-bar-animated"
                                                        :style="{ width: barraProgresso, height: '1.8em', marginRight: 'auto' }"
                                                    >
                                                        {{ dados.item.qtde_lista_total }} / {{ dados.item.qtde_total }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2 px-2">
                                    <div class="col-lg-12 px-2 table-responsive">

  
                                        <button class="btn btn-sm btn-block btn-primary mb-2"
                                        v-if="this.enderecosAlternativos.length > 0"
                                        data-toggle="modal" data-target="#modalEnderecosAlternativos">
                                            Alterar Endereço
                                        </button>

                                        <button class="btn btn-sm btn-block btn-warning mb-2" data-toggle="modal" data-target="#modalConfirmarAnalise">
                                            Enviar Pedido para análise
                                        </button>

                                        <button v-if="this.dados.item.sequencia == 0 && this.dados.item.total_itens > 1 && !this.dados.item.ultimo_da_ista" class="btn btn-sm btn-block btn-success mb-2" data-toggle="modal" data-target="#modalSkipEndereco">
                                            Pular o Endereço para o Final
                                        </button>

                                        <table class="table-sm">
                                            <thead>
                                                <tr style="white-space: nowrap">
                                                    <th>Próximos Endereços</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="line in proximosEnderecos"
                                                    :key="line"
                                                    :style="{
                                                        backgroundColor: '#' + line.statusbackground,
                                                        color: '#' + line.statuscolor,
                                                    }"
                                                >
                                                    <td>
                                                        <div>
                                                            <div style="display: flex; justify-content: space-between">
                                                                <span class="text-left">{{ line }}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <Modal
            id="warningModal"
            title="Aviso"
            :confirmFunction="okWarningModal"
            :cancelFunction="okWarningModal"
            :carregando="carregando"
            confirmText="Ok"
        >
            {{ message }}
        </Modal>
        <Modal id="scanModal" title="Escanear" :carregando="carregando" :buttonList="[]" :cancelFunction="fecharScan">
            <StreamBarcodeReader
                v-if="scanAberto"
                @decode="onDecode"
                @loaded="onLoaded"
                @error="onError"
            ></StreamBarcodeReader>
        </Modal>
        <Modal
            id="modalEnderecosAlternativos"
            title="Outros Endereços"
            :buttonList="[]"
            :noFooter="true"
        >   
           <table class="table table-bordered w-100 table-sm small">
                <thead>
                    <tr>
                        <th>Endeceço</th>
                        <th>Qtde</th>
                        <th class="text-center">Selecionar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="small" v-for="line in enderecosAlternativos" :key="line">
                        <td>{{ line.descricao }}</td>
                        <td>{{ line.qtde }}</td>
                        <td class="text-center">
                            <input type="radio" name="enderecoAlternativo" :value="line.descricao">
                        </td>
                    </tr>
                    
                </tbody>
           </table>
           <hr>
            <button class="btn btn-sm btn-block btn-success" @click="this.setEnderecoAlternativo()">
                Alterar endereço
            </button>
        </Modal>
        <Modal
            id="modalConfirmarAnalise"
            title="Confirme as informações:"
            :confirmFunction="() => enviarParaAnalise()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modalConfirmarAnalise')"
        >
            <span>
                Deseja enviar pedido {{ pedido }} para o status de
                <br>
                "AGUARDANDO PICKING (ENVIADO PARA ANALISE)" ?
            </span>
        </Modal>

        <Modal
            id="modalSkipEndereco"
            title="Confirme as informações:"
            :confirmFunction="() => skipEndereco()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modalSkipEndereco')"
        >
            <span>
                Deseja deixar a coleta deste endereço para o final?
            </span>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import ViewMixin from "./ViewMixin";
import api, { getEnderecoAtual, getUserId, setEnderecoAtual } from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    EnderecoDiferenteException,
    ListaConcluidaException,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import { enterKey, dateFormat, selecionar } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import InputDefaultApp from "../components/InputDefaultApp.vue";
import Modal from "../components/Modal.vue";
import { StreamBarcodeReader } from "vue-barcode-reader";
import Audio from "../services/audioService";

export default {
    name: "ProximoItemPicking",
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        ForbiddenModal,
        Modal,
        StreamBarcodeReader,
        InputDefaultApp
    },
    props: ["id"],
    data: () => {
        return {
            url: window.location.href,
            idname: "idlista",
            baseUrl: "picking",
            title: {
                icon: "fas fa-cash-register",
                text: "Picking",
            },
            sort: "nome",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
            endereco: "",
            scanAberto: false,
            barras: "",
            proximoEndereco: null,
            proximosEnderecos: [],
            enderecosAlternativos: [],
            pedido: null,
            enderecoAnterior: null,
            enderecoNovo: null,
        };
    },
    mounted() {
        this.list();
        this.listProximosEnderecos();
    },
    computed: {
        barraProgresso: function () {
            return (this.dados.item.qtde_lista_total * 100) / this.dados.item.qtde_total + "%";
        },
    },
    methods: {
        enterKey,
        dateFormat,

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
        },

        async list() {
            this.carregando = true;

            try {
                let endereco = getEnderecoAtual();
                let { baseUrl, id } = this;
                let response = await api.get(`/${baseUrl}/proximo-item/${id}`, {
                    params: {
                        endereco,
                    },
                });

                this.dados = response.data;
                this.endereco = endereco;

                this.pedido = this.dados.item.iddocumentos;

                setTimeout(() => {
                    this.listEnderecosAlternativos();
                }, 100);

            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    Audio.success()
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push("/picking/enderecos/" + this.id);
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                console.error(e);
            }

            this.carregando = false;
        },

        async listEnderecosAlternativos() {
            this.carregando = true;

            try {
                let response = await api.post(`/picking/outrosenderecos`, {
                    idProduto: this.dados.item.idprodutos,
                    lote: this.dados.item.lote,
                    validade: this.dados.item.validade,
                    enderecoFiltro: getEnderecoAtual(),
                    qtde: this.dados.item.qtde
                });

                this.enderecosAlternativos = response.data.enderecos;
                setTimeout(() => {
                    selecionar("#barras");
                }, 100);
            } catch (e) {
                this.exception = e;                
                console.error(e);
            }

            this.carregando = false;
        },

        setEnderecoAlternativo() {
            let enderecoAlternativo = document.querySelector('input[name="enderecoAlternativo"]:checked');
            if (enderecoAlternativo) {
                this.enderecoAnterior = this.endereco;
                this.endereco = enderecoAlternativo.value;
                this.novoEndereco = enderecoAlternativo.value;

                setEnderecoAtual(enderecoAlternativo.value);
                this.updateEndereco();

                $("#modalEnderecosAlternativos").modal("hide");
            } else {
                alert("Por favor, selecione o endereço disponível...");
            }
        },

        async listProximosEnderecos() {
            this.carregando = true;

            try {

                let { sort, sortDirection, filtro, perPage, pular, id } = this;
                let response = await api.get(`/picking/enderecos/${id}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                response.data.enderecos.forEach((e, i) => {
                    if (i === 0) {
                        this.proximoEndereco = e;
                    } else {
                        this.proximosEnderecos.push(e);
                    }
                }, this);
            } catch (e) {
                this.exception = e;                
                console.error(e);
            }

            this.carregando = false;
        },

        async updateEndereco() {
            try {
                let endereco = this.endereco;
                let { baseUrl, id } = this;
                await api.post(`/${baseUrl}/update-endereco/${id}`, {
                    enderecoNovo: endereco,
                    enderecoOriginal: this.enderecoAnterior,
                    idproduto: this.dados.item.idprodutos,
                    lote: this.dados.item.lote,
                    validade: this.dados.item.validade,
                    qtde: this.dados.item.qtde,
                    idUsuario: getUserId()
                });

                this.list();
            } catch (e) {
                this.exception = e;                
                console.error(e);
            }
        },

        async enviarParaAnalise(){
            try {
                let { baseUrl, id } = this;
                await api.post(`/${baseUrl}/enviarparaanalise/${id}`, {
                    usuario: getUserId(),
                    endereco: this.endereco,
                    barras: this.dados.item.codbarras,
                    lote: this.dados.item.lote,
                    validade: this.dados.item.validade
                });

                this.closeModal("modalConfirmarAnalise");

                this.$router.push(`/picking/enderecos/${id}`)
            } catch (e) {
                this.exception = e;                
                console.error(e);
            }
        },

        async skipEndereco(){
            try {
                let { baseUrl, id } = this;
                await api.post(`/${baseUrl}/skip-endereco/${id}`, {
                    endereco: this.endereco,
                    idProduto: this.dados.item.idprodutos,
                    idUsuario: getUserId(),
                    lote: this.dados.item.lote,
                    validade: this.dados.item.validade
                });

                this.closeModal("modalConfirmarAnalise");

                this.$router.push(`/picking/enderecos/${id}`)
            } catch (e) {
                this.exception = e;                
                console.error(e);
            }
        },

        async bipar() {
            this.carregando = true;

            try {
                let { baseUrl, id, barras } = this;
                await api.post(`/${baseUrl}/coletar-item/${id}`, { 
                    barras: barras,
                    enderecoNovo: this.novoEndereco
                });

                this.errors = [];
                this.barras = "";

                await this.list();
                
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) 
                {
                    Audio.ops()
                    this.handleValidationException(e);
                    setTimeout(() => {
                        selecionar("#barras");
                    }, 100);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    Audio.success()
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push("/picking/enderecos/" + this.id);
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                console.error(e);
            }

            this.carregando = false;
        },

        okWarningModal() {
            let { exception } = this;
            $("#warningModal").modal("hide");
            if (exception instanceof ListaConcluidaException) {
                Audio.success()
                this.$router.push("/picking");
            }
        },

        handleInput(e) {
            if (e && e.target && e.target.value) {
                this.barras = e.target.value;
            }
            this.bipar();
        },

        abrirScan() {
            this.scanAberto = true;
            $("#scanModal").modal("show");
        },
        fecharScan() {
            this.scanAberto = false;
            $("#scanModal").modal("hide");
        },
        onDecode(r) {
            this.barras = r;

            setTimeout(() => {
                this.handleInput(null);
            }, 100);
        },
        onError(r) {
            console.log(r)
            alert("Não foi possível escanear");
        },
        onLoaded() {
            console.log('scanear');
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

.no-copy {
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;     /* IE/Edge antigo */
  user-select: none;         /* padrão */
}

</style>
